export enum DeviceChannel {
    DesktopBrowser = 2,
    MobileBrowser = 5,
  }